<template>
    <div>
        <div v-if="!wizardStore.followUpCompleted">

            <h5 v-if="wizardStore.bookingTerms || wizardStore.productTerms.length">{{$t('Villkår')}}</h5>
            <div class="card mb-1" v-if="wizardStore.bookingTerms">
                <div class="card-body p-2 terms-body">
                    <p><small v-html="wizardStore.bookingTerms"></small></p>

                    <p v-if="wizardStore.hasFullBookingTerms">
                        <small>
                            <a class="text-underline" :href="wizardStore.termsPageUrl" target="_blank">
                                {{ $t("Les fullstendige vilkår") }} <i class="fa fa-link"></i>
                            </a>
                        </small>
                    </p>
                    <input type="hidden" name="terms_approved" value="0">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" name="terms_approved" value="1" v-model="wizardStore.hasApprovedBookingTerms"> {{ $t("Påkrevd") }} - {{ $t("Jeg godkjenner vilkårene vist ovenfor") }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="card mb-1" v-for="(term, i) in wizardStore.productTerms" :key="i">
                <div class="card-body p-2 terms-body">
                    <small v-if="term.file_url">
                        <a :href="term.file_url" target="_blank" style="text-decoration-line: underline">{{ term.file_name }} <span class="fa fa-external-link"></span></a>
                    </small>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" value="1" v-model="term.approved" class="me-1">
                            <span v-if="term.required">
                                {{ $t("Påkrevd") }} {{ term.text ? ' - ' : ''}}
                            </span>

                            <span class="product-terms-text" v-html="term.text"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="text-end my-2" v-if="!wizardStore.followUpCompleted">
                <div class="btn btn-primary rounded-0 cursor-pointer"
                     :class="{'disabled': wizardStore.isCompletingFollowup}"
                     @click="wizardStore.completeFollowUp">
                    {{
                        $t('Fullfør påmelding')
                    }}
                </div>
            </div>

            <div v-if="wizardStore.followUpError">
                <div class="alert alert-danger">
                    {{ wizardStore.followUpError }}
                </div>
            </div>

            <loadingSpinner :isLoading="wizardStore.isCompletingFollowup"></loadingSpinner>

        </div>
        <div v-if="wizardStore.followUpCompleted" class="mt-2">
            <h3>{{ $t("Takk for din påmelding!") }}</h3>
            <p v-if="wizardStore.followUpDetails.signup_complete_text" v-html="wizardStore.followUpDetails.signup_complete_text"></p>
            <p v-if="!wizardStore.followUpDetails.signup_complete_text">{{ $t('Vi behandler forespørselen din så snart som mulig.') }}</p>
        </div>
    </div>
</template>

<script setup>
    import loadingSpinner from "./loadingSpinner.vue";
    import { useWizardStore } from "./wizardState.js";

    // Initialize the Pinia store
    const wizardStore = useWizardStore();

</script>